import React from 'react';
import { Typography } from '@rcg/ui-react/lib/components';
import { useGlobal } from '@rcg/ui-react';
import { ReactComponent as Arrows } from '../../../../assets/svg/two-way-arrow.svg';
import { ReactComponent as RigntArrow } from '../../../../assets/svg/single-arrow.svg';
import Dictionary from '../../../../utils/dictionary';
import { getRouteType } from '../../../../utils/common';
import useDictionary from '../../../../hooks/useDictionary';
import useStyles from './index.style';

const HeaderSummary = ({ guestFlights }) => {
  const {
    data: { localizedDayjs },
  } = useGlobal();
  const classes = useStyles();
  const getDictionaryValue = useDictionary(Dictionary);

  const routeTypeName = {
    roundtrip: getDictionaryValue(Dictionary.airFlightTypeRoundtrip.key),
    oneWay: getDictionaryValue(Dictionary.airFlightTypeOneWay.key),
    multiCity: getDictionaryValue(Dictionary.airFlightTypeMultiCity.key),
  };

  const routeType = getRouteType(guestFlights, routeTypeName);

  const getDataByRoute = () => {
    return guestFlights.map((route) => {
      const result = {
        confirmationNumbers: route.confirmationNumbers,
        departurDate: route.departDate,
        returningDate: route.departDate,
        departureAirport: route.flightSegments[0]?.departure?.airport?.code,
        arrivalAirport: route.flightSegments.slice(-1)[0].arrival?.airport?.code,
      };
      return result;
    });
  };

  const routeInfo = getDataByRoute();

  const formatedDates = (departDate, returnDate) => {
    const departurelYear = localizedDayjs(departDate).year();
    const returningYear = localizedDayjs(returnDate).year();
    if (returnDate === departDate) {
      return localizedDayjs(returnDate).format('MMM DD, YYYY');
    }
    if (returningYear !== departurelYear) {
      return `${localizedDayjs(departDate).format('MMM DD, YYYY')} - ${localizedDayjs(
        returnDate,
      ).format('MMM DD, YYYY')}`;
    }
    return `${localizedDayjs(departDate).format('MMM DD')} - ${localizedDayjs(returnDate).format(
      'MMM DD, YYYY',
    )}`;
  };

  const renderRoute = (route, isRoundTrip, index) => (
    <div
      key={route.confirmationNumbers}
      className={`routes ${isRoundTrip || routeInfo.length === 1 ? 'one-line' : ''}`}>
      <span>{route.departureAirport}</span>
      {routeType === routeTypeName.roundtrip ? <Arrows /> : <RigntArrow />}
      <span> {route.arrivalAirport}</span>
      <span
        className={`${routeType === routeTypeName.multiCity ? 'dividerClasses' : 'hideDivider'} 
      ${index === 1 && 'dividerSlash'}`}>
        &nbsp;/&nbsp;
      </span>
    </div>
  );

  const uniqueConfirmationNumbers = new Set();
  const multiCityCase = routeType === routeTypeName.multiCity;
  const confirmationNums = routeInfo?.map(({ confirmationNumbers }) => {
    const uniqueKey = confirmationNumbers.join(' / ');
    if (!uniqueConfirmationNumbers.has(uniqueKey)) {
      uniqueConfirmationNumbers.add(uniqueKey);
      return uniqueKey;
    }
    return null;
  });

  return (
    <div className={classes.headerSummary}>
      <div className={`${multiCityCase && 'multiCityCase'} flight`}>
        <Typography variant="subtitle1">
          {getDictionaryValue(Dictionary.airCancellationHeaderFlightLabel.key)}
        </Typography>
        <Typography>{routeType}</Typography>
        <div className="flightsView">
          {routeType === routeTypeName.roundtrip
            ? renderRoute(routeInfo[0], true)
            : routeInfo.map((route, index) => renderRoute(route, false, index))}
        </div>
      </div>
      <div className={`${multiCityCase ? 'datesMultiCityWidth' : 'noMultiCity'} dates`}>
        <Typography variant="subtitle1">
          {getDictionaryValue(Dictionary.airCancellationHeaderDatesLabel.key)}
        </Typography>
        <Typography>
          {routeInfo.length === 2
            ? formatedDates(routeInfo[0].departurDate, routeInfo[1].returningDate)
            : formatedDates(routeInfo[0].departurDate, routeInfo[0].returningDate)}
        </Typography>
      </div>
      <div className="confirmation">
        <Typography variant="subtitle1">
          {confirmationNums.length > 1
            ? getDictionaryValue(Dictionary.airCancellationHeaderConfirmationsLabel.key)
            : getDictionaryValue(Dictionary.airCancellationHeaderConfirmationLabel.key)}
        </Typography>
        {confirmationNums.map((uniqueKey) => {
          return (
            <Typography key={uniqueKey} component="span">
              {uniqueKey}
            </Typography>
          );
        })}
      </div>
      <Typography className="details">
        {getDictionaryValue(Dictionary.airCancellationHeaderViewDetailsLabel.key)}
      </Typography>
    </div>
  );
};

export default HeaderSummary;
